import startCase from "lodash/startCase";
import { razaEventCalendarBaseTitle } from "@/utils/raza-backed-event-calendar-title";

export const RAZA_EVENT_KIND_BACKED_LABEL = "Raza-backed";
export const RAZA_EVENT_OHBAT_DEFAULT_TITLE = "Ohbat majlis";

/** Minimal fields used by list, calendar, upcoming, and dashboard display helpers. */
export type RazaEventLike = {
  ohbatType?: unknown;
  title?: unknown;
  purposeName?: unknown;
  hostName?: unknown;
  hostItsNo?: unknown;
  razaRequest?: { purpose?: unknown } | null;
  sadarat?: { name?: unknown } | null;
};

type RazaEventInput = RazaEventLike | Record<string, unknown>;

function asLike(record: RazaEventInput): RazaEventLike {
  return record as RazaEventLike;
}

function trimStr(v: unknown): string {
  if (v == null) return "";
  return String(v).trim();
}

export function isOhbatRazaEvent(record: RazaEventInput): boolean {
  return asLike(record).ohbatType != null;
}

/** Ohbat subtype (e.g. `Jaman`) or `"Raza-backed"` for raza-backed events. */
export function razaEventKindLabel(record: RazaEventInput): string {
  if (!isOhbatRazaEvent(record)) {
    return RAZA_EVENT_KIND_BACKED_LABEL;
  }
  const type = trimStr(asLike(record).ohbatType);
  return type ? startCase(type) : "—";
}

/** `title`, then `purposeName`, then parent raza request purpose — same precedence as lagat autocomplete. */
export function razaEventPurposeLabel(record: RazaEventInput): string {
  const r = asLike(record);
  const title = trimStr(r.title);
  if (title) return title;
  const purposeName = trimStr(r.purposeName);
  if (purposeName) return purposeName;
  return trimStr(r.razaRequest?.purpose);
}

function ohbatEventHostTitle(record: RazaEventLike): string {
  const hostName = trimStr(record.hostName);
  if (hostName) return hostName;
  const sadaratName = trimStr(record.sadarat?.name);
  if (sadaratName) return sadaratName;
  const maleName = trimStr((record as { sadaratMale?: { name?: unknown } }).sadaratMale?.name);
  if (maleName) return maleName;
  const femaleName = trimStr(
    (record as { sadaratFemale?: { name?: unknown } }).sadaratFemale?.name
  );
  if (femaleName) return femaleName;
  const hostItsNo = trimStr(record.hostItsNo);
  if (hostItsNo) return hostItsNo;
  return RAZA_EVENT_OHBAT_DEFAULT_TITLE;
}

/** Host-centric title for ohbat events; calendar-style label for raza-backed events. */
export function razaEventTitle(record: RazaEventInput): string {
  const r = asLike(record);
  if (isOhbatRazaEvent(record)) {
    return ohbatEventHostTitle(r);
  }
  return razaEventCalendarBaseTitle(r.title, r.hostName, r.hostItsNo, r.purposeName);
}
